<template>
  <div class="highlights-post-item-contents-parts">
    <a class="highlights-post-item-contents-parts__link" :href="snsPost.link">
      <sns-post-item-header-parts :snsPost="snsPost" />

      <p class="post-item-contents-parts__text">
        <span v-html="snsPost.post" />
      </p>

      <p
        class="highlights-post-item-contents-parts__highlight-label"
        v-text="$tc('HomePage.snsHighlightCommentCardLabel')"
      />
    </a>

    <a class="highlights-post-item-contents-parts__thumbnail" :href="snsPost.link">
      <figure class="highlights-post-item-contents-parts__thumbnail">
        <img :src="snsPost.thumbnail" alt="" />
        <figcaption>{{ snsPost.highlightComment.sceneTitle }}</figcaption>
      </figure>
    </a>

    <a class="highlights-post-item-contents-parts__link" :href="snsPost.link">
      <div class="post-item-contents-parts__footer">
        <p class="highlights-post-item-contents-parts__scene-data">
          {{ snsPost.highlightComment.raceDate }} Round {{ snsPost.highlightComment.round }}
          {{ snsPost.highlightComment.circuit }}<br />
          Lap {{ snsPost.highlightComment.lap }} - S{{ snsPost.highlightComment.sector }}
        </p>
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import SnsPostItemHeaderParts from '@/components/HomePage/HomePane/parts/SnsPostItemHeaderParts.vue'
import { SnsPostData } from '@/store/stores/pageStore/HomePage/HomePageStore'

/**
 * HOME SNSコンテンツ 投稿アイテム ハイライトコメント用パーツ
 */
export default defineComponent({
  name: 'HighlightsPostItemContentsParts',
  components: {
    SnsPostItemHeaderParts,
  },
  props: {
    snsPost: {
      type: Object as PropType<SnsPostData>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.highlights-post-item-contents-parts {
  width: 100%;

  &__highlight-label {
    margin-top: min(#{convertPXtoVW(5)}, 5px);
    font-weight: 500;
    font-size: min(#{convertPXtoVW(12)}, 12px);
    line-height: 1.33;
    letter-spacing: 0.04em;
    color: $gray25;
  }

  &__thumbnail {
    display: block;
    width: 100%;
    margin-top: min(#{convertPXtoVW(12)}, 12px);

    figure {
      position: relative;
      display: block;
      width: 100%;
      margin: 0;
      padding-top: 56.25%;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      figcaption {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: min(#{convertPXtoVW(12)}, 12px) min(#{convertPXtoVW(16)}, 16px);
        font-family: $fontSignup;
        font-weight: 500;
        font-size: min(#{convertPXtoVW(12)}, 12px);
        line-height: 1.67;
        letter-spacing: 0.02em;
        font-feature-settings: 'palt' on;
        color: $white;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        background: linear-gradient(180deg, $black 0, rgba($black, 0) 100%);
        z-index: 3;
      }
    }
  }

  &__scene-data {
    margin-top: min(#{convertPXtoVW(8)}, 8px);
    font-weight: 500;
    font-size: min(#{convertPXtoVW(10)}, 10px);
    line-height: 1.2;
    letter-spacing: 0.04em;
    color: $gray25;
  }
}
</style>
